import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import { _money } from './utils';

export function VarianceCell({ variance }) {
  if (variance === 0) {
    return <span className="inline-flex items-center gap-1 text-slate-500"><Minus className="h-3 w-3" />{_money(0)}</span>;
  }
  const pos = variance > 0;
  return (
    <span className={`inline-flex items-center gap-1 font-medium ${pos ? 'text-emerald-700' : 'text-rose-700'}`}>
      {pos ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
      {_money(variance)}
    </span>
  );
}

// iter485 — Compact inline stat for the sticky top bar.
export function MiniStat({ label, value, money = true, emphasize = false }) {
  return (
    <div className="flex items-center gap-1">
      <span className="text-slate-500">{label}:</span>
      <span className={`text-sm ${emphasize ? 'font-bold' : 'font-semibold'}`}>
        {money ? _money(value) : (value ?? 0)}
      </span>
    </div>
  );
}
